import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Printer, Eraser, Bold, Italic, Highlighter, Loader2, Check, Download, Eye, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { resolveLogoUrl } from '../../lib/resolveLogoUrl';
import { moduleApi } from '../../lib/api';
import { useConfirm } from '../ui/ConfirmProvider';

// Bandeau décoratif teal fourni par Emeni (motif exact du document officiel Polpo),
// recadré sur un cycle et répété en CSS pour ne laisser aucune démarcation (2026-09-05).
const BAND_TILE =
    'data:image/png;base64,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';

type CellStyle = {
    text: string;
    bold: boolean;
    italic: boolean;
    highlight: boolean;
    color: string;
    fontFamily: string;
    fontSize: number; // px, plafond souhaité — peut être réduit automatiquement pour tenir dans la case
};

const DEFAULT_STYLE: CellStyle = {
    text: '',
    bold: false,
    italic: false,
    highlight: false,
    color: '#1c3557',
    fontFamily: "'Oswald', Arial, sans-serif",
    fontSize: 12,
};

const FONT_OPTIONS = [
    { value: "'Oswald', Arial, sans-serif", label: 'Oswald' },
    { value: "Arial, sans-serif", label: 'Arial' },
    { value: "'Times New Roman', serif", label: 'Times New Roman' },
    { value: "'Courier New', monospace", label: 'Courier New' },
    { value: "Georgia, serif", label: 'Georgia' },
];

const MIN_FONT_SIZE = 7;

type FieldDef = { id: string; label: string };
type SectionDef = { title: string; columns: string[]; rows: FieldDef[][] };

function buildSections(): SectionDef[] {
    const rowIds = [0, 1, 2, 3];
    return [
        {
            title: 'Viandes bovines',
            columns: ['Née', 'Élevée', 'Abattue'],
            rows: rowIds.map((i) => [
                { id: `bovine_${i}_nee`, label: `Née (ligne ${i + 1})` },
                { id: `bovine_${i}_elevee`, label: `Élevée (ligne ${i + 1})` },
                { id: `bovine_${i}_abattue`, label: `Abattue (ligne ${i + 1})` },
            ]),
        },
        {
            title: 'Préparations à base de viandes bovines',
            columns: ['Nom du produit', 'Née', 'Élevée', 'Abattue'],
            rows: rowIds.map((i) => [
                { id: `prepb_${i}_nom`, label: `Nom du produit (ligne ${i + 1})` },
                { id: `prepb_${i}_nee`, label: `Née (ligne ${i + 1})` },
                { id: `prepb_${i}_elevee`, label: `Élevée (ligne ${i + 1})` },
                { id: `prepb_${i}_abattue`, label: `Abattue (ligne ${i + 1})` },
            ]),
        },
        {
            title: 'Viandes autres que bovines',
            columns: ['Morceau', 'Élevée', 'Abattue'],
            rows: rowIds.map((i) => [
                { id: `autres_${i}_morceau`, label: `Morceau (ligne ${i + 1})` },
                { id: `autres_${i}_elevee`, label: `Élevée (ligne ${i + 1})` },
                { id: `autres_${i}_abattue`, label: `Abattue (ligne ${i + 1})` },
            ]),
        },
        {
            title: 'Préparations à base de viandes autres que bovines',
            columns: ['Nom du produit', 'Élevée', 'Abattue'],
            rows: rowIds.map((i) => [
                { id: `prepa_${i}_nom`, label: `Nom du produit (ligne ${i + 1})` },
                { id: `prepa_${i}_elevee`, label: `Élevée (ligne ${i + 1})` },
                { id: `prepa_${i}_abattue`, label: `Abattue (ligne ${i + 1})` },
            ]),
        },
    ];
}

const SECTIONS = buildSections();

/**
 * « Bovines · ligne 2 · Élevée » — ce que la barre de mise en forme annonce comme cible.
 *
 * Sans cela, une barre unique laisserait l'utilisateur mettre en gras une case qu'il ne regarde pas :
 * le libellé est ce qui remplace les 64 étiquettes qu'on vient de retirer.
 */
const libelleCase = (id: string): string => {
    for (const section of SECTIONS) {
        for (let i = 0; i < section.rows.length; i += 1) {
            const colonne = section.rows[i].findIndex((f) => f.id === id);
            if (colonne >= 0) {
                const titreCourt = section.title.replace(/^Pr\u00e9parations \u00e0 base de /i, 'Préparations ').replace(/^Viandes /i, '');
                return `${titreCourt.charAt(0).toUpperCase()}${titreCourt.slice(1)} · ligne ${i + 1} · ${section.columns[colonne]}`;
            }
        }
    }
    return '';
};


type StyleMap = Record<string, CellStyle>;

/** Réduit la taille de police affichée (jamais la taille choisie par l'utilisateur) jusqu'à ce que
 * le texte tienne dans la case, pour ne jamais déborder à l'impression. */
function AutoFitText({ style }: { style: CellStyle }) {
    const spanRef = useRef<HTMLSpanElement>(null);
    const [displaySize, setDisplaySize] = useState(style.fontSize);

    useLayoutEffect(() => {
        const el = spanRef.current;
        if (!el || !el.parentElement) return;
        let size = style.fontSize;
        el.style.fontSize = `${size}px`;
        const cellEl = el.parentElement;
        let guard = 0;
        while (el.scrollWidth > cellEl.clientWidth && size > MIN_FONT_SIZE && guard < 40) {
            size -= 1;
            el.style.fontSize = `${size}px`;
            guard += 1;
        }
        setDisplaySize(size);
    }, [style.text, style.fontSize, style.fontFamily, style.bold, style.italic]);

    return (
        <span
            ref={spanRef}
            style={{
                fontSize: displaySize,
                fontFamily: style.fontFamily,
                fontWeight: style.bold ? 700 : 400,
                fontStyle: style.italic ? 'italic' : 'normal',
                color: style.color,
                background: style.highlight ? '#fff59d' : 'transparent',
                whiteSpace: 'nowrap',
                padding: style.highlight ? '0 2px' : 0,
            }}
        >
            {style.text}
        </span>
    );
}

export default function OrigineViandesPage() {
    const { user } = useAuth();
    const confirmAction = useConfirm();
    const logoUrl = (user as any)?.logo_url || (user as any)?.logoUrl;
    const companyName = (user as any)?.company_name || user?.name || '';
    const pageRef = useRef<HTMLDivElement>(null);
    /** La case en cours de mise en forme : la barre unique agit sur elle. */
    const [focused, setFocused] = useState<string | null>(null);
    /** L'apercu quitte la colonne de droite (maquette 25b) : il s'ouvre en plein ecran, a l'echelle 1. */
    const [apercuOuvert, setApercuOuvert] = useState(false);
    // Échap ferme l'aperçu. C'est le réflexe de tout le monde devant une surcouche plein écran, et
    // c'était la seule sortie qui manquait : la feuille couvrait toute la largeur du voile, il ne restait
    // quasiment rien à cliquer à côté pour le refermer (Emeni, 19/09).
    useEffect(() => {
        if (!apercuOuvert) return;
        const surEchap = (e: KeyboardEvent) => { if (e.key === 'Escape') setApercuOuvert(false); };
        window.addEventListener('keydown', surEchap);
        return () => window.removeEventListener('keydown', surEchap);
    }, [apercuOuvert]);
    const [exporting, setExporting] = useState<'download' | 'print' | null>(null);

    const [values, setValues] = useState<StyleMap>({});
    const [loading, setLoading] = useState(true);
    const [saveStatus, setSaveStatus] = useState<'idle' | 'saving' | 'saved' | 'error'>('idle');
    const saveTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
    const skipNextSave = useRef(true);

    // Enregistré en D1 (table origine_viandes_data, 1 ligne par client) plutôt qu'en localStorage
    // seul : demande explicite d'Emeni pour ne jamais perdre une saisie liée à un navigateur/poste
    // particulier (2026-09-05).
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await moduleApi.getOrigineViandesData();
                if (!cancelled) setValues(res?.data || {});
            } catch {
                /* pas de donnée existante ou hors-ligne — on part d'un formulaire vide */
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, []);

    useEffect(() => {
        if (loading) return;
        if (skipNextSave.current) { skipNextSave.current = false; return; }
        setSaveStatus('saving');
        if (saveTimer.current) clearTimeout(saveTimer.current);
        saveTimer.current = setTimeout(async () => {
            try {
                await moduleApi.saveOrigineViandesData(values);
                setSaveStatus('saved');
            } catch {
                setSaveStatus('error');
            }
        }, 800);
        return () => { if (saveTimer.current) clearTimeout(saveTimer.current); };
    }, [values, loading]);

    const getStyle = (id: string): CellStyle => values[id] || DEFAULT_STYLE;
    const patch = (id: string, patchObj: Partial<CellStyle>) => {
        setValues((v) => ({ ...v, [id]: { ...(v[id] || DEFAULT_STYLE), ...patchObj } }));
    };

    const clearAll = async () => {
        if (!(await confirmAction({ title: 'Tout effacer ?', description: <>Toutes les valeurs et mises en forme saisies sur l'affiche seront effacées.</>, confirmLabel: 'Tout effacer' }))) return;
        setValues({});
    };

    // Génère un vrai fichier PDF (capture de .ov-page en image + jsPDF), même patron que les factures/devis
    // (invoicePdfGenerator.ts). Remplace window.print() : Emeni ne voulait plus dépendre de la boîte
    // d'impression du navigateur (marges, case "graphiques d'arrière-plan", sidebar visible derrière la
    // fenêtre selon les réglages) — ici le PDF téléchargé ou ouvert pour impression est TOUJOURS identique
    // à l'aperçu, sans aucune trace du site (2026-09-05).
    const buildPdf = async () => {
        const node = pageRef.current;
        if (!node) return null;
        const { toPng } = await import('html-to-image');
        const { jsPDF } = await import('jspdf');

        const imgs = Array.from(node.querySelectorAll('img'));
        await Promise.all(imgs.map((img) => new Promise<void>((res) => {
            if (img.complete) { res(); return; }
            img.onload = () => res();
            img.onerror = () => res();
            setTimeout(res, 1500);
        })));

        // Même filet de sécurité que la facture/le contrat : sans largeur/hauteur explicites en pixels,
        // le logo (object-fit:contain) peut ne pas se restituer fiablement dans le <foreignObject> SVG
        // utilisé par html-to-image pour capturer le DOM.
        const logoImg = node.querySelector<HTMLImageElement>('.ov-logo-zone img');
        let restoreLogoStyle: (() => void) | null = null;
        if (logoImg && logoImg.naturalWidth && logoImg.naturalHeight) {
            const prevWidth = logoImg.style.width, prevHeight = logoImg.style.height;
            const maxWidth = 359, maxHeight = 113; // 95mm/30mm à 96dpi — suit la zone resserrée ci-dessous
            const ratio = logoImg.naturalWidth / logoImg.naturalHeight;
            let width = maxWidth, height = maxWidth / ratio;
            if (height > maxHeight) { height = maxHeight; width = maxHeight * ratio; }
            logoImg.style.width = `${Math.round(width)}px`;
            logoImg.style.height = `${Math.round(height)}px`;
            restoreLogoStyle = () => { logoImg.style.width = prevWidth; logoImg.style.height = prevHeight; };
        }

        try {
            const dataUrl = await toPng(node, {
                cacheBust: true,
                pixelRatio: 2,
                backgroundColor: '#ffffff',
                width: node.offsetWidth,
                height: node.offsetHeight,
            });
            const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
            // L'AFFICHE SORTAIT ECRASEE D'ENVIRON 9 % (signale par Emeni : « le PDF ne ressort pas comme
            // l'apercu »). La capture etait prise aux dimensions REELLES du noeud — ~794 x 1228 px, soit
            // un rapport 210/325 — puis posee de force dans 210 x 297 mm. Hauteurs de case et interligne
            // faux, logo remonte. On place desormais l'image d'apres son propre rapport, centree : un
            // debordement residuel retrecit l'affiche au lieu de la deformer.
            const PAGE_W = 210, PAGE_H = 297;
            const k = Math.min(PAGE_W / node.offsetWidth, PAGE_H / node.offsetHeight);
            const w = node.offsetWidth * k, h = node.offsetHeight * k;
            pdf.addImage(dataUrl, 'PNG', (PAGE_W - w) / 2, (PAGE_H - h) / 2, w, h, undefined, 'SLOW');
            return pdf;
        } finally {
            restoreLogoStyle?.();
        }
    };

    const safeFileName = (companyName || 'etablissement').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-+|-+$/g, '');

    const handleDownloadPdf = async () => {
        setExporting('download');
        try {
            const pdf = await buildPdf();
            pdf?.save(`Origine-des-viandes-${safeFileName}.pdf`);
        } finally {
            setExporting(null);
        }
    };

    const handlePrintPdf = async () => {
        setExporting('print');
        try {
            const pdf = await buildPdf();
            if (!pdf) return;
            const blobUrl = pdf.output('bloburl');
            window.open(blobUrl as unknown as string, '_blank');
        } finally {
            setExporting(null);
        }
    };

    return (
        <div className="ov-wrapper">
            <style>{`
                /* L'ÉCRAN suit les jetons du thème (clair et sombre). Seule la feuille .ov-page, plus bas,
                   garde ses couleurs propres : c'est l'affiche imprimée, identique quel que soit le thème.
                   Les anciens var(--surface) / var(--border) n'existaient pas et retombaient sur du blanc en
                   sombre (signalé par Emeni le 2026-09-19). */
                .ov-toolbar{ display:flex; gap:10px; align-items:center; margin-bottom:16px; }
                .ov-toolbar button{
                    display:flex; align-items:center; gap:6px;
                    background:var(--text-primary); color:var(--bg-card); border:1px solid var(--text-primary); padding:8px 16px;
                    border-radius:999px; font-size:13px; font-weight:600; cursor:pointer;
                }
                .ov-toolbar button:hover{ opacity:.9; }
                .ov-toolbar button.secondary{ background:var(--bg-card); color:var(--text-primary); border-color:var(--border-color); }
                .ov-toolbar button.secondary:hover{ border-color:var(--text-primary); opacity:1; }
                .ov-save-status{ display:flex; align-items:center; gap:5px; font-size:12px; color:var(--text-muted); }
                .ov-spin{ animation:ov-spin 0.8s linear infinite; }
                @keyframes ov-spin{ to{ transform:rotate(360deg); } }

                .ov-field-block{ margin-bottom:14px; }
                .ov-field-label{ font-size:11px; font-weight:700; color:var(--text-muted); text-transform:uppercase; margin-bottom:4px; display:block; }
                .ov-field-row{ display:flex; gap:6px; align-items:center; flex-wrap:wrap; }
                .ov-field-row input[type=text]{
                    flex:1 1 160px; min-width:120px; padding:6px 8px; border:1px solid var(--border-color); border-radius:5px; font-size:13px;
                    background:var(--bg-card); color:var(--text-primary);
                }
                .ov-mini-btn{
                    width:28px; height:28px; display:flex; align-items:center; justify-content:center;
                    border:1px solid var(--border-color); border-radius:5px; background:var(--bg-card); cursor:pointer; color:var(--text-secondary);
                }
                .ov-mini-btn.active{ background:var(--text-primary); color:var(--bg-card); border-color:var(--text-primary); }
                .ov-mini-select, .ov-mini-size, .ov-mini-color{
                    border:1px solid var(--border-color); border-radius:5px; background:var(--bg-card); color:var(--text-primary);
                }
                .ov-mini-select{ padding:5px 4px; font-size:12px; }
                .ov-mini-size{ width:44px; padding:5px 4px; font-size:12px; }
                .ov-mini-color{ width:28px; height:28px; padding:0; cursor:pointer; }

                .ov-section-title{ font-size:14px; font-weight:800; color:var(--text-primary); text-transform:uppercase; margin:20px 0 10px 0; }

                /* Flex plutôt qu'une grille calée sur un point de rupture Tailwind : la largeur de la
                   fenêtre entière (barre latérale comprise) ne reflète pas la largeur réellement
                   disponible pour cette page, ce qui empêchait le passage en 2 colonnes. Ici le
                   passage en pile ne se fait que si la place manque vraiment (mobile / panneau étroit). */
                /* L'apercu ne partage plus l'ecran avec la saisie : il s'ouvre en surcouche, a
                   l'echelle 1. Colle a 62 % dans une colonne de droite, il etait illisible et volait la
                   moitie de la place au panneau de saisie. */
                .ov-layout{ display:block; }
                .ov-form-panel{ width:100%; }
                .ov-preview-outer{ width:100%; }
                .ov-preview-scale{ display:flex; justify-content:center; }

                .ov-format-bar{
                    position:sticky; top:0; z-index:5; display:flex; align-items:center; gap:6px;
                    flex-wrap:wrap; padding:8px 10px; margin-bottom:14px; border-radius:11px;
                    background:var(--bg-card); border:1px solid var(--border-color);
                }
                .ov-format-cible{ font-size:11.5px; font-weight:700; margin-right:4px; white-space:nowrap; }
                .ov-format-vide{ font-size:11.5px; opacity:.6; }

                .ov-edit-section{ margin-bottom:20px; }
                .ov-edit-head{ display:flex; align-items:baseline; justify-content:space-between; gap:10px; flex-wrap:wrap; margin-bottom:6px; }
                .ov-edit-count{ font-size:11px; opacity:.6; white-space:nowrap; }
                .ov-edit-table{ width:100%; border-collapse:collapse; table-layout:fixed; }
                .ov-edit-table th{
                    font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:.07em;
                    text-align:left; padding:0 6px 4px; opacity:.6;
                }
                .ov-edit-table td{ padding:0 3px 6px; }
                .ov-edit-table input{
                    width:100%; height:34px; padding:0 9px; font-size:13px; border-radius:8px;
                    border:1px solid var(--border-color); background:var(--bg-card); color:var(--text-primary); outline:none;
                }
                .ov-edit-table input:focus, .ov-edit-table input.ov-cell-active{ border-color:var(--text-primary); }

                .ov-apercu-voile{
                    position:fixed; inset:0; z-index:60; background:rgba(15,20,25,.6);
                    overflow:auto; padding:24px; display:flex; justify-content:center; align-items:flex-start;
                }
                /* Dans le voile, la feuille se limite à sa propre largeur : sans ça elle occupait les
                   100% du conteneur, et le clic « à côté » pour fermer n'atteignait jamais le voile. */
                .ov-apercu-voile .ov-preview-outer{ width:auto; }
                .ov-apercu-fermer{
                    position:fixed; top:16px; right:16px; z-index:61;
                    display:inline-flex; align-items:center; gap:7px; height:36px; padding:0 15px;
                    border-radius:999px; border:1px solid rgba(255,255,255,.35); background:rgba(15,20,25,.82);
                    color:#fff; font-size:13px; font-weight:600; cursor:pointer;
                }
                .ov-apercu-fermer:hover{ background:rgba(15,20,25,.95); }

                /* -webkit-print-color-adjust hérite aux enfants : posé ici une seule fois, ça couvre
                   aussi bien le bandeau que le surlignage jaune inline sur le texte, sans quoi
                   Chrome/Edge n'impriment aucune couleur/image de fond tant que l'utilisateur ne
                   coche pas "Graphiques d'arrière-plan" dans la boîte d'impression — tout disparaissait
                   à l'export (Emeni, 2026-09-05). */
                /* HAUTEUR FIXE, plus min-height : le contenu mesurait ~325 mm et la boite grandissait
                   silencieusement, d'ou la capture au mauvais rapport et l'affiche ecrasee a l'export.
                   Le rythme vertical ci-dessous a ete resserre pour tenir dans 297 mm — aucune couleur,
                   police, largeur ni ordre ne change, seulement des espacements. Environ 10 mm de
                   reserve restent sous les 297 mm, pour qu'une police un peu plus grande dans une case
                   ne fasse pas repartir le debordement. */
                .ov-page{
                    width:210mm; height:297mm; margin:0 auto; background:#fff;
                    position:relative; overflow:hidden; box-shadow:0 0 12px rgba(0,0,0,.15);
                    -webkit-print-color-adjust:exact; print-color-adjust:exact; color-adjust:exact;
                }
                .ov-side-band{
                    position:absolute; top:0; bottom:0; width:14mm;
                    background-color:#8ecbc1;
                    background-image:url("${BAND_TILE}");
                    background-size:14mm 11.74mm;
                    background-repeat:repeat-y;
                    background-position:top center;
                }
                .ov-side-band.left{ left:0; }
                .ov-side-band.right{ right:0; }

                .ov-content{ margin:0 34mm; padding:12mm 0; font-family:'Oswald', Arial, sans-serif; }

                .ov-logo-zone{
                    display:flex; justify-content:center; align-items:center;
                    padding-top:3mm; margin-bottom:4mm; min-height:30mm;
                }
                .ov-logo-zone img{ display:block; max-height:30mm; max-width:95mm; object-fit:contain; margin:0 auto; }
                .ov-logo-zone .ov-logo-placeholder{
                    display:inline-flex; align-items:center; justify-content:center;
                    height:30mm; width:95mm; border:1.5px dashed #bbb; color:#999;
                    font-size:11px; text-transform:uppercase; letter-spacing:.05em;
                }

                .ov-title{
                    text-align:center; color:#8ecbc1; font-weight:500; font-size:24px;
                    letter-spacing:.02em; text-transform:uppercase; margin:0 0 3.5mm 0;
                }
                .ov-rule{ border:none; border-top:1.5px dotted #1c3557; width:60%; margin:0 auto 6mm auto; }

                .ov-section{
                    color:#1c3557; font-weight:600; font-size:15px; text-transform:uppercase;
                    letter-spacing:.02em; margin:5mm 0 2mm 0; display:flex; align-items:center; gap:6px;
                }
                .ov-section::before{ content:''; display:inline-block; width:3px; height:14px; background:#8ecbc1; }

                .ov-table{ width:100%; border-collapse:collapse; table-layout:fixed; }
                .ov-table th{
                    border:1.3px solid #1c3557; padding:2mm 3mm; font-size:12px;
                    color:#1c3557; font-weight:600; text-transform:uppercase; text-align:center;
                    letter-spacing:.02em; background:#fff;
                }
                /* display:table-cell (par defaut) doit rester intact sur le <td> lui-meme, sinon il
                   perd son role de cellule et les colonnes s'empilent en bloc au lieu de s'aligner
                   cote a cote. Le centrage vertical se fait sur un conteneur interne a la place. */
                .ov-td{
                    border:1.3px solid #1c3557; height:8mm; padding:0; overflow:hidden;
                }
                .ov-td-inner{
                    height:8mm; padding:0 3mm; display:flex; align-items:center; overflow:hidden;
                }

                .ov-wrapper{ padding:20px; }

                @media print{
                    /* Le padding de l'écran (et le gap du flex layout) s'ajoutait à la largeur fixe
                       de 210mm de la page : sous "Marges: Aucune" (la vraie impression bord-à-bord,
                       sans le redimensionnement automatique que Chrome applique en coulisses avec
                       "Marges: Par défaut"), cet excédent dépassait la feuille et coupait la bande +
                       la dernière colonne à droite (Emeni, 2026-09-05). */
                    .ov-wrapper{ padding:0; }
                    .ov-layout{ gap:0; }
                    .ov-toolbar, .ov-form-panel, .ov-format-bar{ display:none; }
                    .ov-preview-outer{ position:static; flex:none; min-width:0; }
                    .ov-preview-scale{ transform:none; margin-bottom:0; display:block; }
                    .ov-apercu-voile{ position:static; inset:auto; background:none; padding:0; display:block; overflow:visible; }
                    .ov-apercu-fermer{ display:none; }
                    .ov-page{ margin:0; box-shadow:none; }
                    @page{ size:A4; margin:0; }
                }
            `}</style>

            <div className="ov-toolbar no-print">
                <button onClick={handleDownloadPdf} disabled={exporting !== null}>
                    {exporting === 'download' ? <Loader2 size={16} className="ov-spin" /> : <Download size={16} />}
                    Télécharger en PDF
                </button>
                <button onClick={handlePrintPdf} disabled={exporting !== null}>
                    {exporting === 'print' ? <Loader2 size={16} className="ov-spin" /> : <Printer size={16} />}
                    Imprimer
                </button>
                {/* L'APERCU S'OUVRE A LA DEMANDE, en plein ecran et a l'echelle 1 (maquette 25b). Colle
                    a 62 % dans la colonne de droite, il etait illisible et volait la moitie de la place
                    au panneau de saisie. */}
                <button onClick={() => setApercuOuvert(true)}><Eye size={16} /> Aperçu</button>
                <button className="secondary" onClick={clearAll}><Eraser size={16} /> Effacer le formulaire</button>
                <span className="ov-save-status">
                    {saveStatus === 'saving' && <><Loader2 size={14} className="ov-spin" /> Enregistrement…</>}
                    {saveStatus === 'saved' && <><Check size={14} /> Enregistré</>}
                    {saveStatus === 'error' && 'Échec de l\'enregistrement — nouvelle tentative au prochain changement'}
                </span>
            </div>

            {loading ? (
                <div style={{ padding: 40, color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Loader2 size={16} className="ov-spin" /> Chargement du formulaire…
                </div>
            ) : (
            <div className="ov-layout">
                <div className="ov-form-panel">
                    {/* UNE SEULE BARRE DE MISE EN FORME, collante, qui agit sur la case ayant le focus.
                        Chaque case portait auparavant ses six contrôles : sur 64 cases, cela faisait près
                        de 400 boutons à l'écran pour un document qui en compte 64. La barre NOMME SA CIBLE
                        — « Bovines · ligne 2 · Élevée » — sinon on ne sait pas ce qu'on est en train de
                        mettre en gras. */}
                    <div className="ov-format-bar">
                        {focused ? (
                            <>
                                <span className="ov-format-cible">{libelleCase(focused)}</span>
                                <button type="button" className={`ov-mini-btn${getStyle(focused).bold ? ' active' : ''}`}
                                    title="Gras" onClick={() => patch(focused, { bold: !getStyle(focused).bold })}><Bold size={14} /></button>
                                <button type="button" className={`ov-mini-btn${getStyle(focused).italic ? ' active' : ''}`}
                                    title="Italique" onClick={() => patch(focused, { italic: !getStyle(focused).italic })}><Italic size={14} /></button>
                                <button type="button" className={`ov-mini-btn${getStyle(focused).highlight ? ' active' : ''}`}
                                    title="Surligner" onClick={() => patch(focused, { highlight: !getStyle(focused).highlight })}><Highlighter size={14} /></button>
                                <input type="color" className="ov-mini-color" title="Couleur du texte"
                                    value={getStyle(focused).color} onChange={(e) => patch(focused, { color: e.target.value })} />
                                <select className="ov-mini-select" title="Police"
                                    value={getStyle(focused).fontFamily} onChange={(e) => patch(focused, { fontFamily: e.target.value })}>
                                    {FONT_OPTIONS.map((f) => <option key={f.value} value={f.value}>{f.label}</option>)}
                                </select>
                                <input type="number" className="ov-mini-size" min={8} max={22}
                                    title="Taille (max — réduite automatiquement si ça déborde)"
                                    value={getStyle(focused).fontSize}
                                    onChange={(e) => patch(focused, { fontSize: Number(e.target.value) || DEFAULT_STYLE.fontSize })} />
                            </>
                        ) : (
                            <span className="ov-format-vide">Cliquez dans une case pour la mettre en forme.</span>
                        )}
                    </div>

                    {SECTIONS.map((section) => {
                        // « 2 lignes sur 4 remplies » : une ligne compte des qu'une de ses cases porte
                        // du texte — c'est ce qui dira, d'un coup d'oeil, ce qui reste a saisir.
                        const remplies = section.rows.filter((row) => row.some((f) => (getStyle(f.id).text || '').trim())).length;
                        return (
                            <div key={section.title} className="ov-edit-section">
                                <div className="ov-edit-head">
                                    <span className="ov-section-title">{section.title}</span>
                                    <span className="ov-edit-count">{remplies} ligne{remplies > 1 ? 's' : ''} sur {section.rows.length} remplie{remplies > 1 ? 's' : ''}</span>
                                </div>
                                {/* UNE CASE DE L'EDITEUR = UNE CASE DU DOCUMENT : les memes colonnes, dans
                                    le meme ordre. On sait ou l'on ecrit sans avoir a lire une etiquette. */}
                                <table className="ov-edit-table">
                                    <thead>
                                        <tr>{section.columns.map((c) => <th key={c}>{c}</th>)}</tr>
                                    </thead>
                                    <tbody>
                                        {section.rows.map((row, rowIdx) => (
                                            <tr key={rowIdx}>
                                                {row.map((field) => (
                                                    <td key={field.id}>
                                                        <input
                                                            type="text"
                                                            value={getStyle(field.id).text}
                                                            onFocus={() => setFocused(field.id)}
                                                            onChange={(e) => patch(field.id, { text: e.target.value })}
                                                            className={focused === field.id ? 'ov-cell-active' : ''}
                                                        />
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        );
                    })}
                </div>

                {/* La page reste MONTEE en permanence, meme apercu ferme : buildPdf() capture ce noeud,
                    et l'export doit marcher sans avoir a ouvrir l'apercu d'abord. Elle est simplement
                    hors du champ visuel tant qu'on ne la demande pas. */}
                {/* La sortie, nommée et toujours visible — un aperçu plein écran sans bouton de fermeture
                    est un cul-de-sac. Elle est fixée à la fenêtre, donc atteignable même après avoir fait
                    défiler la feuille. */}
                {apercuOuvert && (
                    <button type="button" className="ov-apercu-fermer" onClick={() => setApercuOuvert(false)}>
                        <X size={14} /> Fermer l'aperçu
                    </button>
                )}
                <div
                    className={apercuOuvert ? 'ov-apercu-voile' : ''}
                    onClick={apercuOuvert ? () => setApercuOuvert(false) : undefined}
                    style={apercuOuvert ? undefined : { position: 'absolute', left: -99999, top: 0, width: '210mm' }}
                >
                <div className="ov-preview-outer" onClick={(e) => e.stopPropagation()}>
                    <div className="ov-preview-scale">
                        <div className="ov-page" ref={pageRef}>
                            <div className="ov-side-band left" />
                            <div className="ov-side-band right" />

                            <div className="ov-content">
                                <div className="ov-logo-zone">
                                    {logoUrl
                                        ? <img src={resolveLogoUrl(logoUrl)} alt={companyName} />
                                        : <div className="ov-logo-placeholder">Logo non configuré</div>}
                                </div>

                                <h1 className="ov-title">Origine des viandes servies</h1>
                                <hr className="ov-rule" />

                                {SECTIONS.map((section) => (
                                    <React.Fragment key={section.title}>
                                        <h2 className="ov-section">{section.title}</h2>
                                        <table className="ov-table">
                                            <thead>
                                                <tr>{section.columns.map((c) => <th key={c}>{c}</th>)}</tr>
                                            </thead>
                                            <tbody>
                                                {section.rows.map((row, rowIdx) => (
                                                    <tr key={rowIdx}>
                                                        {row.map((field) => (
                                                            <td className="ov-td" key={field.id}>
                                                                <div className="ov-td-inner">
                                                                    <AutoFitText style={getStyle(field.id)} />
                                                                </div>
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            )}
        </div>
    );
}
